<template>
  <div class="all">
    <div class="dymall" :style="{ right: rightPosition }">
      <div>
        <GoodsView></GoodsView>
      </div>
      <div>
        <OrderView :posMsg="rightPosition"></OrderView>
      </div>
      <div>
        <MyView></MyView>
      </div>
    </div>
    <nav>
      <div @click="changePosition('商城')">数据</div>
      <div @click="changePosition('订单')">订单</div>
      <div @click="changePosition('我的')">我的</div>
    </nav>
  </div>
</template>

<script>
import GoodsView from './AllPage/GoodsView.vue';
import OrderView from './AllPage/OrderView.vue';
import MyView from './AllPage/MyView.vue';
export default {
  components: {
    GoodsView,
    OrderView,
    MyView
  },
  data() {
    return {
      rightPosition: '0vw', // 初始值为0vw
    };
  },
  methods: {
    changePosition(item) {
      if (item === '订单') {
        this.rightPosition = '100vw';
      } else if (item === '我的') {
        this.rightPosition = '200vw';
      } else {
        this.rightPosition = '0vw'; // 其他项的定位
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.all {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .dymall {
    width: 300vw;
    height: 92vh;
    font-size: 5vh;
    display: flex;
    position: relative;
    right: 0vw;

    div {
      width: 100vw;
      height: 100%;
    }
  }
}

nav {
  width: 100vw;
  height: 8vh;
  background-color: gray;
  display: flex;

  div {
    flex: 1;
    border-left: 20rem solid rgb(155, 155, 155);
    border-right: 20rem solid rgb(155, 155, 155);
    border-radius: 50rem;
    background-color: rgb(202, 202, 202);
    color: gray;
    font-size: 3vh;
    font-weight: 800;
    text-align: center;
    line-height: 8vh;
    cursor: pointer;
  }
}
</style>
